/** Play the dictation key-click (extension `#click-mp3` parity). */
export function playDictationClick(volume: number): void {
  try {
    const audio = new Audio('/audio/click.mp3');
    audio.volume = Math.min(1, Math.max(0, Number.isFinite(volume) ? volume : 0));
    void audio.play().catch(() => {
      // Autoplay / missing asset — ignore
    });
  } catch {
    // ignore
  }
}
